import Vue from 'vue'
import Vuex from 'vuex'
import { loginApi, registerApi, getUserInfoApi } from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: !!localStorage.getItem('token'),
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
    token: localStorage.getItem('token') || ''
  },
  getters: {
    isLogin: state => state.isLogin,
    userInfo: state => state.userInfo,
    token: state => state.token
  },
  mutations: {
    SET_LOGIN_STATUS(state, status) {
      state.isLogin = status
    },
    SET_USER_INFO(state, userInfo) {
      // Ensure avatar URL has correct path format
      if (userInfo.avatar) {
        userInfo.avatar = userInfo.avatar.startsWith('/') ? userInfo.avatar : '/' + userInfo.avatar
      }
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    CLEAR_USER_INFO(state) {
      state.isLogin = false
      state.userInfo = null
      state.token = ''
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    }
  },
  actions: {
    // 登录
    async login({ commit }, userData) {
      try {
        const response = await loginApi(userData)
        if (response.code === '200') {
          commit('SET_LOGIN_STATUS', true)
          commit('SET_USER_INFO', response.data)
          commit('SET_TOKEN', response.data.access_token)
          return Promise.resolve(response)
        } else {
          return Promise.reject(new Error(response.message || '登录失败'))
        }
      } catch (error) {
        return Promise.reject(error)
      }
    },
    
    // 注册
    async register({ commit }, userData) {
      try {
        const response = await registerApi(userData)
        if (response.code === '200') {
          commit('SET_LOGIN_STATUS', true)
          commit('SET_USER_INFO', response.data)
          commit('SET_TOKEN', response.data.access_token)
          return Promise.resolve(response)
        } else {
          return Promise.reject(new Error(response.message || '注册失败'))
        }
      } catch (error) {
        return Promise.reject(error)
      }
    },
    
    // 获取用户信息
    async getUserInfo({ commit, state }) {
      // 检查localStorage中的token，确保与state同步
      const localStorageToken = localStorage.getItem('token')
      if (!localStorageToken) {
        commit('CLEAR_USER_INFO')
        return
      }
      
      try {
        // 不要手动添加token参数，让请求拦截器自动处理
        const response = await getUserInfoApi()
        if (response.code === '200') {
          commit('SET_USER_INFO', response.data)
          return Promise.resolve(response)
        } else if (response.code === '401' || response.code === '403') {
          // API返回未授权或禁止访问错误，清除用户状态
          commit('CLEAR_USER_INFO')
        } else {
          // 其他错误，不清除用户状态，但可能需要提示用户
          console.error('获取用户信息失败:', response.message)
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
        // 只有当收到明确的401错误时，才清除用户状态
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          commit('CLEAR_USER_INFO')
        }
        // 其他错误（如网络错误、服务器暂时不可用等），保持登录状态
      }
    },
    
    // 退出登录
    logout({ commit }) {
      commit('CLEAR_USER_INFO')
    }
  },
  modules: {
  }
})
